export const cyan = {
  900: '#066552',
  800: '#088C72',
  700: '#0AA989',
  600: '#0BC09C',
  500: '#0DD5AD',
  400: '#4DE0C2',
  300: '#7DE8D3',
  200: '#A4EFE0',
  100: '#C6F5EB',
  50: '#E4FAF5',
}
